import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "antd/dist/antd.css";
import { DatePicker } from 'antd';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import { MDBDataTable } from 'mdbreact';
// import { ExportReactCSV } from './ExportReactCSV';
import { Alert } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { ExportReactCSV } from '../reports/ExportReactCSV';


export default function AccountLocation({ company_id }) {

  const [columnData, setColumnData] = useState([])
  const [rowData, setRowData] = useState([])
  const [rowDataForPDF, setRowDataForPDF] = useState([])

  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }


  useEffect(() => {

    axios.get(baseURL + "/get_audit/" + (company_id + "||account_location"))
      .then((res) => {

        let column_data = []

        column_data.push(
          {
            label: 'Location ID',
            field: 'location_id',
            sort: 'asc',
            width: 150
          },
          {
            label: 'Location Name',
            field: 'location_name',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Account ID',
            field: 'company_id',
            sort: 'asc',
            width: 150
          },
          {
            label: 'Account Name',
            field: 'company_name',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Country',
            field: 'country',
            sort: 'asc',
            width: 150
          },
          {
            label: 'State',
            field: 'state',
            sort: 'asc',
            width: 100
          },
          {
            label: 'City/Town',
            field: 'city',
            sort: 'asc',
            width: 100
          },
          {
            label: 'GDS Code',
            field: 'city_code',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Location Type',
            field: 'location_type',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Active Status',
            field: 'is_active',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created By',
            field: 'created_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated By',
            field: 'updated_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created On',
            field: 'created_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated On',
            field: 'modified_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'IP Address',
            field: 'ip_address',
            sort: 'asc',
            width: 100
          }

        )


        setColumnData(column_data);

        let rows_data = [];

        const myDataSet = res.data;
        let row_data_pdf = []
        for (var index = 0; index < res.data.length; index++) {

          let row_data_pdf_temp = [];
          let rowItem = {};
          const val = myDataSet[index];
          rowItem["company_id"] = val.company_id
          rowItem["company_name"] = val.company_name
          rowItem["location_name"] = val.location_name
          rowItem["country"] = val.country
          rowItem["state"] = val.state
          rowItem["city"] = val.city
          rowItem["city_code"] = val.city_code
          rowItem["location_type"] = val.location_type
          rowItem["created_by"] = val.created_by
          rowItem["updated_by"] = val.updated_by
          rowItem["is_active"] = val.is_active === true ? "Active" : "Inactive"
          rowItem["created_date"] = formatDate_withTime(new Date(val.created_date))
          rowItem["modified_date"] = formatDate_withTime(new Date(val.modified_date))
          rowItem["location_id"] = val.location_id
          rowItem["ip_address"] = val.ip_address

          rows_data.push(rowItem)

          //for pdf
          row_data_pdf_temp = [
            rowItem["location_id"], rowItem["location_name"], rowItem["company_id"], rowItem["company_name"],  
            rowItem["country"], rowItem["state"], rowItem["city"],
            rowItem["city_code"], rowItem["location_type"], rowItem["is_active"], rowItem["created_by"],
            rowItem["updated_by"],  rowItem["created_date"], rowItem["modified_date"], 
            rowItem["ip_address"]
          ]
          row_data_pdf.push(row_data_pdf_temp);


        }


        setRowData(rows_data)
        setRowDataForPDF(row_data_pdf);
      }).catch((e) => { });



  }, [])


  //Table Data
  const data = {
    columns: columnData,
    rows: rowData
  };

  //Export in PDF
  const handleExportPDF = (e) => {

    // e.preventDefault();
    // Default export is a4 paper, portrait, using millimeters for units
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [24, 24]
    });

    const col = columnData.map((val) => val.label);
    const row = rowDataForPDF

    autoTable(doc, {
      head: [col],
      body: row
    });
    doc.save("Account Location Audit/Event Log.pdf");

  }



  return (
    <>

      <div className="row mt-3">
        <div className="col-md-12">
          <h5 className="mb-3">Account Location Audit/Event Log: </h5>
          <MDBDataTable
            bordered
            large={true}
            data={data}
            sortable={true}
            responsiveLg={true}
            noBottomColumns={true}
            className='cust-table'
            btn

          />

        </div>

      </div>
      {/* download Excel and PDF start*/}
      <div className="col-md-10 mb-4 mt-4">
        {data.rows.length > 0 ? (<>
          <div className="row">
            <div className="col-md-4 mb-4 ">
              <ExportReactCSV data={data} report_name={"Account Location Audit Log"} />
            </div>
            {/* <div className="col-md-1 mb-4 "></div> */}
            <div className="col-md-4 mb-4 ">
              <button type="button" className="btn btn-secondary" onClick={(e) => handleExportPDF(e)}>
                Download PDF
              </button>
            </div>
          </div>
        </>
        )
          : ""
        }
      </div>
      {/* download Excel and PDF end*/}
      
      

    </>
  );
}
